import React from 'react';
import PropTypes from 'prop-types';
import { Carousel, CtaButton, CtaShell } from '@web/molecules';
import { SectionIntro, BackgroundColorContainer, Eyebrow } from '@web/atoms';
import { HoverImageCard } from '../HoverImageCard';
import {
  StyledImageCardsList,
  ImageCardsListContainer,
  MobileImageCardsListContainer,
  CardWrapper,
  ButtonContainer,
} from './styles.js';

export const HoverImageCards = ({
  headline,
  subheadline,
  items,
  isCarousel = true,
  link,
  backgroundColor = 'background.base',
  fontColor = 'text.secondary',
  eyebrow,
  level,
  typography = 'heading1',
  headerText,
}) => {
  const subheadlineHasContent =
    typeof subheadline === 'string' ||
    (typeof subheadline === 'object' &&
      !!subheadline?.props?.content?.content?.[0]?.content?.[0]?.text);
  return (
    <BackgroundColorContainer $bgColor={backgroundColor}>
      <StyledImageCardsList
        $fontColor={fontColor}
        $noSubheadline={!subheadlineHasContent}
      >
        {eyebrow && <Eyebrow fontColor={fontColor}>{eyebrow}</Eyebrow>}
        {(headline || subheadline) && (
          <SectionIntro
            headline={headline}
            subheadline={subheadlineHasContent ? subheadline : undefined}
            headingLevel={level}
            typography={typography}
          />
        )}
        <ImageCardsListContainer count={items.length} isCarousel={isCarousel}>
          {items.map((item, i) => (
            <CardWrapper key={i}>
              <HoverImageCard {...item} />
            </CardWrapper>
          ))}
        </ImageCardsListContainer>
        <MobileImageCardsListContainer isCarousel={isCarousel}>
          <Carousel buttonPosition="40" dotPadding={6} showDots={false}>
            {items.map((item, i) => (
              <CardWrapper key={i}>
                <HoverImageCard {...item} />
              </CardWrapper>
            ))}
          </Carousel>
        </MobileImageCardsListContainer>
        {link && (
          <ButtonContainer>
            <CtaShell
              alignment={link.alignment}
              fullWidth={link.fullWidth}
              fullWidthMobile={link.fullWidthMobile}
              fullWidthDesktop={link.fullWidthDesktop}
            >
              <CtaButton
                {...link}
                href={link.target}
                icon={link.icon}
                iconAlignment={link.iconAlignment}
                headerText={link.headerText || headerText}
                variant={link.variant}
              >
                {link.text}
              </CtaButton>
            </CtaShell>
          </ButtonContainer>
        )}
      </StyledImageCardsList>
    </BackgroundColorContainer>
  );
};

HoverImageCards.displayName = 'ImageCardsList';

HoverImageCards.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isCarousel: PropTypes.bool,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }),
  backgroundColor: PropTypes.string,
  fontColor: PropTypes.string,
  eyebrow: PropTypes.string,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};
